import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";

const trig = "h-10 rounded-xl border-black/10 bg-white text-sm text-ink focus:ring-brand/30";

export function ModelPicker({ providers, provider, model, onProvider, onModel, idPrefix, stacked }) {
  const models = providers?.[provider]?.models || [];
  return (
    <div className={`grid gap-3 ${stacked ? "grid-cols-1" : "grid-cols-2"}`}>
      <div>
        <label className="mb-1.5 block text-xs font-medium text-mist">AI engine</label>
        <Select value={provider} onValueChange={onProvider}>
          <SelectTrigger data-testid={`${idPrefix}-provider-select`} className={trig}><SelectValue /></SelectTrigger>
          <SelectContent className="rounded-xl">
            {Object.entries(providers || {}).map(([id, p]) => (
              <SelectItem key={id} value={id}>{p.label}</SelectItem>
            ))}
          </SelectContent>
        </Select>
      </div>
      <div>
        <label className="mb-1.5 block text-xs font-medium text-mist">Model</label>
        <Select value={model} onValueChange={onModel}>
          <SelectTrigger data-testid={`${idPrefix}-model-select`} className={trig}><SelectValue /></SelectTrigger>
          <SelectContent className="max-h-72 rounded-xl">
            {models.map((m) => (
              <SelectItem key={m.id} value={m.id}>
                <span className="flex items-center gap-2">
                  {m.label}
                  {m.tag === "recommended" && <span className="rounded-full bg-brand-soft px-1.5 py-0.5 text-[10px] font-medium text-brand">best</span>}
                  {m.tag === "new" && <span className="rounded-full bg-[#FFF4E5] px-1.5 py-0.5 text-[10px] font-medium text-[#C93400]">new</span>}
                </span>
              </SelectItem>
            ))}
          </SelectContent>
        </Select>
      </div>
    </div>
  );
}
